/* src/app/shared/services/dialog/confirm-dialog/confirm-dialog.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.confirm-dialog {
  font-size: 1rem;
  padding: 1.8125em 1.625em;
  position: relative;
}
.confirm-dialog .close-button {
  position: absolute;
  top: 0;
  right: 9px;
  background: none;
  outline: none;
}
.confirm-dialog .close-button.cdk-focused.cdk-keyboard-focused {
  border: none;
  outline: none;
  background: none;
}
.confirm-dialog .mat-mdc-dialog-title {
  font-family: "Roboto Flex", sans-serif;
  font-weight: 500;
}
.confirm-dialog .mat-mdc-dialog-title + .mat-mdc-dialog-content {
  font-family: "Roboto Flex", sans-serif;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
  margin-top: -2em;
}
.confirm-dialog .mat-mdc-dialog-title.note-title {
  margin-bottom: 8px;
  font-size: 16px;
  font-weight: 700;
  color: #817b7b;
}
.confirm-dialog .mat-mdc-dialog-content {
  padding: 2em 0 0 0;
}
.confirm-dialog .mat-mdc-dialog-actions {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  margin-top: 2.25em;
  margin-bottom: 0;
  padding: 0;
}
@media screen and (min-width: 48rem) {
  .confirm-dialog .mat-mdc-dialog-actions {
    flex-direction: row;
  }
}
.confirm-dialog .mat-mdc-dialog-actions button,
.confirm-dialog .mat-mdc-dialog-actions .mat-mdc-raised-button {
  width: 100%;
  margin: 0 0 0.5rem 0;
}
@media screen and (min-width: 48rem) {
  .confirm-dialog .mat-mdc-dialog-actions button,
  .confirm-dialog .mat-mdc-dialog-actions .mat-mdc-raised-button {
    width: auto;
    margin: 0 0.5rem 0.5rem 0.5rem;
  }
}
.confirm-dialog.alternate .mat-mdc-dialog-content {
  overflow: visible;
}
.confirm-dialog.alternate .mat-mdc-dialog-content .dialog-content {
  font-size: 1.5em;
  font-weight: 700;
  line-height: 1.5;
  text-align: center;
}
.confirm-dialog.alternate .mat-mdc-dialog-actions {
  padding-bottom: 2rem;
  flex-direction: row-reverse;
}
.confirm-dialog.alternate .mat-mdc-dialog-actions .mat-mdc-raised-button {
  height: 33px;
  font-size: 0.8em;
  line-height: 1;
}
.confirm-dialog.ppi-dialog .close-button {
  top: 1.5em;
  right: 1.5em;
  color: #121212;
}
.confirm-dialog.ppi-dialog .mat-mdc-dialog-title {
  font-size: 2em;
  font-weight: 400;
  line-height: 1;
  color: #121212;
  --header-underline-gap: .85rem;
  position: relative;
  padding-bottom: var(--header-underline-gap);
}
.confirm-dialog.ppi-dialog .mat-mdc-dialog-title::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  max-width: 4.5rem;
  height: 0.25rem;
  background-color: #004791;
}
.confirm-dialog.ppi-dialog .mat-mdc-dialog-content {
  font-size: 1em;
  padding: 3em 0 0;
  color: #121212 !important;
}
.confirm-dialog.ppi-dialog .mat-mdc-dialog-actions {
  gap: 1em;
}
@media screen and (min-width: 48rem) {
  .confirm-dialog.ppi-dialog .mat-mdc-dialog-actions {
    flex-direction: row-reverse;
    justify-content: flex-end;
  }
}
.confirm-dialog.ppi-dialog .mat-mdc-dialog-actions .mat-mdc-raised-button {
  border-radius: 9999px;
  padding: 0 1.5em;
  margin: 0;
}
.confirm-dialog.ppi-dialog .mat-mdc-dialog-actions .mat-mdc-raised-button .button__content {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  justify-content: center;
}
.confirm-dialog.ppi-dialog .mat-mdc-dialog-actions .mat-mdc-raised-button .button__content::before,
.confirm-dialog.ppi-dialog .mat-mdc-dialog-actions .mat-mdc-raised-button .button__content::after {
  content: "";
  font-family: "Material Icons";
  font-size: 1.5em;
  font-weight: 400;
}
.confirm-dialog.ppi-dialog .mat-mdc-dialog-actions .mat-mdc-raised-button .button__content__yes::after {
  content: "chevron_right";
}
.confirm-dialog.ppi-dialog .mat-mdc-dialog-actions .mat-mdc-raised-button .button__content__no::before {
  content: "chevron_left";
}
/*# sourceMappingURL=confirm-dialog.component.css.map */
